/**
 * Checks if a promo code is applied to the given totals object
 * @param {totals} totals totals with promo code added
 * @param {string} promoCode Promo or coupon code to check
 * @returns {boolean} True if the coupon is present and applied, false otherwise
 */
const isPromoCodeApplied = function (totals, promoCode) {
    return !!(totals.discounts.find(function (d) {
        return d.couponCode === promoCode && d.applied;
    }));
};

module.exports = {
    isPromoCodeApplied
};
